/* eslint-disable no-use-before-define */

import React from "react";
import {
  ActivityIndicator,
  Button,
  FlatList,
  Image,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { bindActionCreators } from "redux";
import MenuButton from "../components/MenuButton";
import { connect } from "react-redux";
import {
  initBoxConnection,
  insertSerialNum,
  selectNetwork,
  wifiScan,
} from "../redux/actions/box";
import { errorColors, RepositColours, RepositStyles } from "../utils/styles";
import goTo from "../utils/goTo";
import Phone from "../utils/Phone";
import WebHeading from "../components/WebHeading";
import Icon from "react-native-vector-icons/FontAwesome";
import storage from "../utils/storage";

const ChevRight = (
  <Icon
    name="chevron-right"
    size={20}
    color="#CECED2"
    style={{ fontWeight: "300" }}
  />
);
const questionCircle = (
  <Icon name="warning" size={100} color={errorColors.orange} />
);

const HotspotConnection = ({ status, rescan }) => {
  return status === "OFFLINE" ? (
    <View style={{ flex: 1, justifyContent: "center" }}>
      <View style={{ flex: 4, justifyContent: "center" }}>
        <Text style={{ textAlign: "center" }}>{questionCircle}</Text>
        <Text style={{ ...RepositStyles.paragraphText, marginVertical: 20 }}>
          We were unable to connect to your installer hotspot. Please ensure you
          have a mobile hotspot set up with the credentials:
        </Text>
        <Text style={{ ...RepositStyles.paragraphText, marginBottom: 10 }}>
          SSID: <Text style={{ fontWeight: "bold" }}>RepositInstall</Text>
        </Text>
        <Text style={{ ...RepositStyles.paragraphText, marginBottom: 10 }}>
          Password: <Text style={{ fontWeight: "bold" }}>InstallerReset</Text>
        </Text>
        <Text style={{ ...RepositStyles.paragraphText, marginTop: 20 }}>
          Once that is set up wait 60 seconds for the Reposit Box to connect and
          then tap rescan.
        </Text>
      </View>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Button
          title="Rescan"
          onPress={() => rescan()}
          color={RepositColours.blue}
        />
      </View>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Text style={RepositStyles.paragraphText}>
          If the problem persists <Phone>call Reposit on</Phone>
        </Text>
      </View>
    </View>
  ) : (
    <View style={{ flex: 1, backgroundColor: "#3CA5D5" }}>
      <View style={{ flex: 4 }} />
      <View style={{ flex: 1 }}>
        <ActivityIndicator size="large" color="white" />
      </View>
      <View style={{ flex: 6 }}>
        <Text
          style={{
            ...RepositStyles.headerText,
            marginTop: 20,
            marginBottom: 10,
            color: "white",
          }}
        >
          Connecting to Installer Hotspot
        </Text>
        <Text
          style={{
            ...RepositStyles.paragraphText,
            textAlign: "center",
            color: "white",
          }}
        >
          Please wait
        </Text>
      </View>
    </View>
  );
};

const WifiSearch = ({ status, rescan }) => {
  return status === "FAILED" ? (
    <View style={{ flex: 1, justifyContent: "center" }}>
      <Text style={{ textAlign: "center" }}>{questionCircle}</Text>
      <Text style={{ ...RepositStyles.paragraphText, marginVertical: 20 }}>
        We were unable to scan for wifi hotspots. Please try again by tapping
        rescan. If the problem persists please <Phone>call Reposit on</Phone>
      </Text>
      <Button
        title="Rescan"
        onPress={() => rescan()}
        color={RepositColours.blue}
      />
    </View>
  ) : (
    <View style={{ flex: 1, backgroundColor: "#3CA5D5" }}>
      <View style={{ flex: 4 }} />
      <View style={{ flex: 1 }}>
        <ActivityIndicator size="large" color="white" />
      </View>
      <View style={{ flex: 6 }}>
        <Text
          style={{
            ...RepositStyles.headerText,
            marginTop: 20,
            marginBottom: 10,
            color: "white",
          }}
        >
          Scanning wifi networks
        </Text>
        <Text
          style={{
            ...RepositStyles.paragraphText,
            textAlign: "center",
            color: "white",
          }}
        >
          Please wait
        </Text>
      </View>
    </View>
  );
};

const WifiSelectionItem = ({ item, onPress, navigate }) => {
  return (
    <TouchableOpacity
      onPress={() =>
        onPress(item.essid, item.db, item.signal_level, item.channel, navigate)
      }
      style={{
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: "#C8C7CC",
      }}
    >
      <View
        style={{
          marginVertical: 24,
          justifyContent: "space-between",
          alignItems: "stretch",
          flexDirection: "row",
        }}
      >
        <View style={{ flex: 1, alignItems: "center" }}>
          <Image
            style={{ width: 50, height: 40, flex: 1 }}
            resizeMode="contain"
            source={
              item.db > -60
                ? require("../img/wifi/wifi_4@2x.png")
                : item.db > -70
                ? require("../img/wifi/wifi_3@2x.png")
                : item.db > -80
                ? require("../img/wifi/wifi_2@2x.png")
                : item.db > -90
                ? require("../img/wifi/wifi_1@2x.png")
                : require("../img/wifi/wifi_0@2x.png")
            }
          ></Image>
        </View>
        <View
          style={{ flex: 2, flexDirection: "column", justifyContent: "center" }}
        >
          <Text
            style={{ ...RepositStyles.welcomeText, color: RepositColours.blue }}
          >
            {item.essid}
          </Text>
          <Text
            style={{
              ...RepositStyles.paragraphText,
              marginHorizontal: 0,
              color: RepositColours.lightGrey,
            }}
          >
            Channel {item.channel}
          </Text>
        </View>
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          {ChevRight}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const WifiSelection = ({ networks, scan, scanning, onPress }) => {
  const networksWithoutInstaller = networks.filter(
    (item) => item.essid !== "RepositInstall"
  );
  return (
    <View style={{ flex: 1 }}>
      <View style={{ backgroundColor: "#EFEFF4" }}>
        <Text style={{ ...RepositStyles.headerText, marginVertical: 20 }}>
          Select a Wireless Network
        </Text>
      </View>
      {Platform.OS !== "web" ? (
        <FlatList
          onRefresh={() => scan()}
          refreshing={scanning}
          data={networksWithoutInstaller}
          renderItem={({ item }) => (
            <WifiSelectionItem item={item} onPress={onPress} />
          )}
        />
      ) : (
        <ScrollView>
          {networksWithoutInstaller.map((item) => (
            <WifiSelectionItem key={item.essid} item={item} onPress={onPress} />
          ))}
        </ScrollView>
      )}
    </View>
  );
};

const mapStateToProps = (state) => ({
  box: state.box,
});

const mapDispatchToProps = (dispatch) => {
  return {
    boxActions: bindActionCreators(
      { initBoxConnection, wifiScan, selectNetwork, insertSerialNum },
      dispatch
    ),
  };
};

class WirelessConnection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { state: "HOTSPOT", disconectModal: false };
  }
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };
  componentWillReceiveProps(nextProps) {
    const nextCon = nextProps.box.connection.initConnectionStatus;
    const thisCon = this.props.box.connection.initConnectionStatus;
    if (nextCon === "ONLINE" && thisCon !== "ONLINE") {
      this.setState({ state: "WIFI" });
    }
    if (nextCon === "OFFLINE" && thisCon === "ONLINE") {
      this.setState({ disconnectModal: true });
    }
  }

  componentDidMount() {
    this.rescanAll();
  }

  rescan = () => {
    let serialNum = this.props.box.serialNumber;
    if (!serialNum) {
      storage
        .load({ key: "serialNum" })
        .then((ret) => {
          this.props.boxActions.insertSerialNum(ret);
          this.props.boxActions.wifiScan(ret);
        })
        .catch((err) => {
          console.log(err);
          this.props.boxActions.wifiScan(this.props.box.serialNumber);
        });
    } else {
      this.props.boxActions.wifiScan(this.props.box.serialNumber);
    }
  };

  rescanAll = () => {
    let serialNum = this.props.box.serialNumber;
    if (!serialNum) {
      storage
        .load({ key: "serialNum" })
        .then((ret) => {
          this.props.boxActions.insertSerialNum(ret);
          this.props.boxActions.initBoxConnection(ret);
          this.props.boxActions.wifiScan(ret);
        })
        .catch((err) => {
          this.props.boxActions.initBoxConnection(this.props.box.serialNumber);
          this.props.boxActions.wifiScan(this.props.box.serialNumber);
        });
    } else {
      this.props.boxActions.initBoxConnection(this.props.box.serialNumber);
      this.props.boxActions.wifiScan(this.props.box.serialNumber);
    }
  };

  onWifiPress = (essid, strength, quality, channel) => {
    this.props.boxActions.selectNetwork(essid, strength, quality, channel);
    goTo(this.props.navigation, "WirelessSelection");
  };

  render() {
    const wifiNetworks = this.props.box.connection.wifi.availableNetworks;

    let navigate;
    if (Platform.OS !== "web") {
      navigate = this.props.navigation.navigate;
    } else {
      navigate = null;
    }
    return (
      <View style={styles.wrapper}>
        <WebHeading title="New Setup" />
        {this.state.state === "HOTSPOT" ? (
          <HotspotConnection
            status={this.props.box.connection.initConnectionStatus}
            rescan={this.rescanAll}
          />
        ) : this.props.box.connection.wifi.availableNetworks.length > 0 ? (
          <WifiSelection
            scan={this.rescan}
            scanning={this.props.box.connection.wifi.status === "SCANNING"}
            networks={wifiNetworks}
            onPress={this.onWifiPress}
            navigate={navigate}
          />
        ) : (
          <WifiSearch
            status={this.props.box.connection.wifi.status}
            rescan={this.rescan}
          />
        )}
        {/*<HotspotConnection/>*/}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "white",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
  },
  heading: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#DFE6F5",
    marginHorizontal: 20,
  },
  headingText: { fontSize: 32, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 30,
  },
  bodyText: {
    marginVertical: 10,
  },
  stepBox: {
    flexDirection: "row",
    marginBottom: 50,
    marginHorizontal: 50,
  },
  addressBox: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: StyleSheet.hairlineWidth,
    marginHorizontal: 20,
    marginVertical: 10,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WirelessConnection);



// WEBPACK FOOTER //
// ./src/containers/WirelessConnection.js